import './styles.scss';

import info from '../../../../images/info-icon.svg';
import question from '../../../../images/info-tooltip.svg';

import React, {CSSProperties, ReactNode, useMemo, useState} from 'react';

export enum AppTooltipIconMode {
    INFO,
    QUESTION,
}

interface AppTooltipIconProps {
    mode?: AppTooltipIconMode;
    style?: CSSProperties;
    TooltipContent?: ReactNode;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const AppTooltipIcon = ({
    mode = AppTooltipIconMode.INFO,
    TooltipContent,
    onClick
}: AppTooltipIconProps) => {

    const [showTooltip, setShowTooltip] = useState(false);

    const icon = useMemo(() => {
        switch (mode) {
            case AppTooltipIconMode.INFO:
                return info;
            case AppTooltipIconMode.QUESTION:
                return question;
        }
    }, [mode]);
    
    return (
        <div className='app-tooltip-icon' onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} onClick={onClick}>
            <span className={'app-tooltip-icon__icon'}>
                <img src={icon} />
            </span>
            {TooltipContent && <div className={`app-tooltip-icon__tooltip ${showTooltip ? 'visible' : ''}`}>{TooltipContent}</div>}
        </div>
    );
};
